import { useState } from 'react';

export default function useLocalStorage(key, initialValue, storage = window.localStorage) {
    // The initialValue arg is only used if there is nothing in localStorage ...
    // ... otherwise we use the value in localStorage so state persist through a page refresh.
    // We pass a function to useState so localStorage lookup only happens once.
    // We wrap in try/catch in case localStorage is unavailable
    const [item, setInnerValue] = useState(() => {
        return getStorageItem(key, initialValue, storage);
    });

    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    const setValue = value => {
        const newValue = value instanceof Function ? value(item) : value;
        setInnerValue(newValue);
        storage.setItem(key, JSON.stringify(newValue));
    };

    // Alternatively we could update localStorage inside useEffect ...
    // ... but this would run every render and it really only needs ...
    // ... to happen when the returned setValue function is called.
    /*
    useEffect(() => {
      window.localStorage.setItem(key, JSON.stringify(item));
    });
    */

    return [item, setValue];
}

export function getStorageItem(key, noSetValue, storage = window.localStorage) {
    try {
        const lsItem = storage.getItem(key);
        return lsItem ? JSON.parse(lsItem) : noSetValue;
    } catch (error) {
        // Return default value if JSON parsing fails
        console.log(error);
        return noSetValue;
    }
}
